import Joi from "joi-browser";

function errorsAsString(errors) {
    let err = errors[0];
    if (err.type === "string.regex.base") {
        return "must be a URL";
    }
}

const OrganizationProfileSchema = Joi.object().keys({
    name: Joi.string().trim().required().label("Organization Name"),
    about: Joi.string().max(1024).allow(null, "").label("Description"),
    defaultCurrency: Joi.object().keys({
        value: Joi.number().label("Currency").required(),
    }),
    abbreviation: Joi.string()
        .min(2)
        .max(5)
        .optional()
        .allow("")
        .regex(/^[a-zA-Z0-9]*$/)
        .regex(/^\S*$/)
        .label("Abbreviation")
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                switch (err.type) {
                    case "string.regex.base":
                        return "should not include spaces";
                    case "string.min":
                        return "can't be less than 2 letters";
                    case "string.max":
                        return "can not exceed 5 letters";
                    default:
                        break;
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    website: Joi.string()
        .allow(null, "")
        .regex(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
        )
        .label("Organization Website")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
    linkedin: Joi.string()
        .label("Organization Linkedin Profile")
        .regex(
            /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g
        )
        .allow(null, "")
        .error((errors) => {
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(errors),
                },
            };
        }),
    address: Joi.string().allow(null, "").label("Address"),
    supportedCountryId: Joi.number().required().label("Country"),
    email: Joi.string()
        .label("E-mail")
        .required()
        .regex(/^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/)
        .error((errors) => {
            function errorsAsString() {
                let err = errors[0];
                if (err.type === "any.empty") {
                    return "can't be an empty field.";
                } else if (err.type === "string.regex.base") {
                    return "should be somthing like this: example@domain.com";
                }
            }
            return {
                template: " {{message}}",
                context: {
                    errors: errors.length,
                    message: errorsAsString(),
                },
            };
        }),
    industries: Joi.array(),
});

export default { OrganizationProfileSchema };
